import { render } from "./myBookmark.vue?vue&type=template&id=95bd9cc0"
import script from "./myBookmark.vue?vue&type=script&lang=js"
export * from "./myBookmark.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__